import React, { useState, useEffect } from "react";
import { ReusableOnboardingButton } from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { FormControl, OutlinedInput } from "@material-ui/core";
import { Col, Form, Row, Modal, Image } from "react-bootstrap";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import Switch from "react-switch";
import TimeInput from "material-ui-time-picker";
import moment from "moment";
import { InputCharacterCheck } from "../../../../../../../../function/InputCharNumCheckFunc";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import BusinessHoursMultiplePopup from "../../../../../businessandHoursofOperations/PopupScreen/BusinessHoursMultiplePopup";
import { useFormik } from "formik";
import * as yup from "yup";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clear_all_errors } from "../../../../../../../../store/actions/errorActions";
import { update_item_menu_setup } from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";

const foodTime = ["breakfast", "lunch", "dinner"];

const dayArray = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const Availability = (props) => {
  const back = () => {
    props.onChange(4);
    window.scroll(0, 0);
  };

  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    formData.currentState = 3;
    formData.runingTrack = 4;
    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  // const onSubmit = () => {
  //   props.onChange(6);
  //   window.scroll(0, 0);
  // };

  const onClickNext = (e) => {
    e.preventDefault();

    formik.handleSubmit();
  };

  const [state, setState] = useState({
    checkPoint: false,
    monday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    tuesday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    wednesday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    thursday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    friday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    saturday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    sunday: {
      open: false,
      multiple_timings: [
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 8),
          closing_time: new Date(2020, 1, 1, 11),
          description: "Breakfast",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 13),
          closing_time: new Date(2020, 1, 1, 15),
          description: "Lunch",
        },
        {
          open: true,
          opening_time: new Date(2020, 1, 1, 17),
          closing_time: new Date(2020, 1, 1, 23),
          description: "Dinner",
        },
      ],
    },
    auto_accept: true,
    errors: [],
  });

  const handleChangeOpeningCloseing = (time, day, inputType, index) => {
    if (inputType === "opening_time") {
      // let state = state;
      let dayData = state[day];
      let multipleOpening = dayData.multiple_timings;
      multipleOpening[index].opening_time = new Date(time);
      setState({ ...state });
    } else if (inputType === "closing_time") {
      // let state = state;
      let dayData = state[day];
      let multipleClosing = dayData.multiple_timings;
      multipleClosing[index].closing_time = new Date(time);
      setState({ ...state });
    }
  };

  const handleChangeMultipleHoursToggle = (day, hours, index) => (e) => {
    // let state = state;
    let dayData = state[day];
    let multipleToggle = dayData.multiple_timings;
    multipleToggle[index].open = !multipleToggle[index].open;
    setState({
      ...state,
      // state: state,-
    });
  };

  const copyMultipleTimeFunction = (day) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    let index = days.indexOf(day);
    days = days.slice(index + 1, days.length);
    let daysData = {};
    days.forEach((day) => {
      daysData[day] = JSON.parse(JSON.stringify(dayData));
    });
    setState({
      ...state,
      ...daysData,
    });
  };

  const copyMultipleTimeFunctionError = (e) => {
    const { errors } = state;
    errors.description = "Description Is Required";
    setState({
      ...state,
      errors: errors,
    });
  };

  const handleChangeInputTextArray = (day, index) => (e) => {
    // let state = state;
    let dayData = state[day];
    let multipleText = dayData.multiple_timings;
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    multipleText[index][e.target.name] = newData;

    setState({
      ...state,
      checkPoint: false,
    });
  };

  /*****************************************
   * @DESC - Multiple Time Add Handlers
   ******************************************/
  const onMultipleAddHandler = (day) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let phone = dayData.multiple_timings;
    let dayDataDesc =
      phone[phone.length - 1] && phone[phone.length - 1].description;
    if (dayDataDesc === "") {
      const { errors } = state;
      errors.description = "Description Is Required";
      setState({
        ...state,
        errors: errors,
      });
    } else {
      let newMultiple = {
        open: true,
        opening_time: new Date(2020, 1, 1, 8),
        closing_time: new Date(2020, 1, 1, 23),
        description: "",
      };
      phone.push(newMultiple);
      setState({
        ...state,
        checkPoint: true,
      });
    }
  };

  const onMultileDeleteHandler = (day, index) => (e) => {
    e.preventDefault();
    // let state = state;
    let dayData = state[day];
    let phone = dayData.multiple_timings;
    if (phone.length === 1) {
      window.alert("Cannot Delete elements");
    } else {
      phone.splice(index, 1);
      setState({ ...state, errors: [] });
    }
    props.clear_all_errors();
  };

  const onFocusOut = (e) => {
    const { errors } = state;
    if (e.target.value === "") {
      errors[e.target.name] = `Description Is Required`;
    } else {
      errors[e.target.name] = "";
    }
    setState({
      ...state,
      errors: errors,
    });
  };

  /****************************
   * @DESC - DAY TOGGLER -
   ***************************/
  const onDayOpenCloseHanlder = (day, foodTime, multiple) => (e) => {
    let dayData = state[day];
    dayData.open = !dayData.open;
    setState({ ...state });
    if (dayData.open === false && multiple === "single") {
      dayData.breakfast.open = false;
      dayData.lunch.open = false;
      dayData.dinner.open = false;
    } else {
      setState({ ...state });
    }
    if (
      state["monday"].open === false &&
      state["tuesday"].open === false &&
      state["wednesday"].open === false &&
      state["thursday"].open === false &&
      state["friday"].open === false &&
      state["saturday"].open === false &&
      state["sunday"].open === false &&
      multiple === "multiple"
    ) {
      setState({
        ...state,
      });
    } else {
      setState({
        ...state,
      });
    }
  };

  const [itemAvaiblity, setItemAvaiblity] = useState([
    "All Day",
    "Breakfast",
    "Lunch",
    "Dinner",
    "Supper",
    "Brucnh",
    "Other Times",
  ]);

  const addRemoveItem = (itemName) => {
    let data = formik.values.opening_time;
    if (!data.includes(itemName)) {
      data.push(itemName);
      formik.setFieldValue("opening_time", data);
    } else {
      let removeItem = data.filter((item) => {
        return item !== itemName;
      });
      formik.setFieldValue("opening_time", removeItem);
    }
  };

  const onChangeItemStatus = () => {
    formik.setFieldValue("status", !formik.values.status);
  };
  const onChangeAutoAccept = () => {
    formik.setFieldValue("auto_accept", !formik.values.auto_accept);
  };
  const onSuccess = () => {
    props.onChange(6);
    window.scroll(0, 0);
  };

  const formik = useFormik({
    initialValues: {
      status: false,
      auto_accept: true,
      opening_time: [],
      counter_number: "",
    },

    onSubmit: (values) => {
      let mondayData = state.monday;
      let tuesdayData = state.tuesday;
      let wednesdayData = state.wednesday;
      let thursdayData = state.thursday;
      let fridayData = state.friday;
      let saturdayData = state.saturday;
      let sundayData = state.sunday;

      var newMondayData = mondayData.multiple_timings;
      newMondayData.forEach((elements) => {
        elements.opening_time = moment(elements.opening_time).valueOf();
        elements.closing_time = moment(elements.closing_time).valueOf();
      });
      mondayData.multiple_timings = newMondayData;

      var newTuesdayData = tuesdayData.multiple_timings;
      newTuesdayData.forEach((elements) => {
        elements.opening_time = moment(elements.opening_time).valueOf();
        elements.closing_time = moment(elements.closing_time).valueOf();
      });
      tuesdayData.multiple_timings = newTuesdayData;

      var newWednesdayData = wednesdayData.multiple_timings;
      newWednesdayData.forEach((elements) => {
        elements.opening_time = moment(elements.opening_time).valueOf();
        elements.closing_time = moment(elements.closing_time).valueOf();
      });
      wednesdayData.multiple_timings = newWednesdayData;

      var newThursdayData = thursdayData.multiple_timings;
      newThursdayData.forEach((elements) => {
        elements.opening_time = moment(elements.opening_time).valueOf();
        elements.closing_time = moment(elements.closing_time).valueOf();
      });
      thursdayData.multiple_timings = newThursdayData;

      var newFridayData = fridayData.multiple_timings;
      newFridayData.forEach((elements) => {
        elements.opening_time = moment(elements.opening_time).valueOf();
        elements.closing_time = moment(elements.closing_time).valueOf();
      });
      fridayData.multiple_timings = newFridayData;

      var newSaturdayData = saturdayData.multiple_timings;
      newSaturdayData.forEach((elements) => {
        elements.opening_time = moment(elements.opening_time).valueOf();
        elements.closing_time = moment(elements.closing_time).valueOf();
      });
      saturdayData.multiple_timings = newSaturdayData;

      var newSundayData = sundayData.multiple_timings;
      newSundayData.forEach((elements) => {
        elements.opening_time = moment(elements.opening_time).valueOf();
        elements.closing_time = moment(elements.closing_time).valueOf();
      });
      sundayData.multiple_timings = newSundayData;

      let formData = {};

      formData = { ...formik.values };
      formData.monday = mondayData;
      formData.tuesday = tuesdayData;
      formData.wednesday = wednesdayData;
      formData.thursday = thursdayData;
      formData.friday = fridayData;
      formData.saturday = saturdayData;
      formData.sunday = sundayData;
      const token = props.auth.user.accessToken;
      formData.currentState = 5;
      formData.runingTrack = 6;
      console.log(formData);
      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
      //props.onChange(6);
    },
  });
  const [show24Hours, setShow24Hours] = useState(false);
  const handleClose24Hours = () => setShow24Hours(false);
  const handleShow24Hours = () => setShow24Hours(true);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      let tempState = state;
      if (data && data.monday && data.monday.multiple_timings.length === 0) {
        tempState.monday = state.monday;
      } else {
        tempState.monday = data.monday;
      }
      if (data && data.monday && data.monday.open) {
        tempState.monday = { ...tempState.monday, open: data.monday.open };
      }
      // tuesday

      if (data && data.tuesday && data.tuesday.multiple_timings.length === 0)
        tempState.tuesday = state.tuesday;
      else tempState.tuesday = data.tuesday;

      if (data && data.tuesday && data.tuesday.open) {
        tempState.tuesday = { ...tempState.tuesday, open: data.tuesday.open };
      }

      // wednesday

      if (
        data &&
        data.wednesday &&
        data.wednesday.multiple_timings.length === 0
      ) {
        tempState.wednesday = state.wednesday;
      } else {
        tempState.wednesday = data.wednesday;
      }
      if (data && data.wednesday && data.wednesday.open) {
        tempState.wednesday = {
          ...tempState.wednesday,
          open: data.wednesday.open,
        };
      }

      // thursday

      if (
        data &&
        data.thursday &&
        data.thursday.multiple_timings.length !== 0
      ) {
        tempState.thursday = data.thursday;
      } else {
        tempState.thursday = state.thursday;
      }
      if (data && data.thursday && data.thursday.open) {
        tempState.thursday = {
          ...tempState.thursday,
          open: data.thursday.open,
        };
      }

      // friday

      if (data && data.friday && data.friday.multiple_timings.length !== 0) {
        tempState.friday = data.friday;
      } else {
        tempState.friday = state.friday;
      }
      if (data && data.friday && data.friday.open) {
        tempState.friday = { ...tempState.friday, open: data.friday.open };
      }

      // saturday
      if (
        data &&
        data.saturday &&
        data.saturday.multiple_timings.length !== 0
      ) {
        tempState.saturday = data.saturday;
      } else {
        tempState.saturday = state.saturday;
      }
      if (data && data.saturday && data.saturday.open) {
        tempState.saturday = {
          ...tempState.saturday,
          open: data.saturday.open,
        };
      }

      // sunday
      if (data && data.sunday && data.sunday.multiple_timings.length !== 0) {
        tempState.sunday = data.sunday;
      } else {
        tempState.sunday = state.sunday;
      }
      if (data && data.sunday && data.sunday.open) {
        tempState.sunday = { ...tempState.sunday, open: data.sunday.open };
      }

      formik.setFieldValue("status", data.status);
      formik.setFieldValue("opening_time", data.opening_time);
      formik.setFieldValue("auto_accept", data.auto_accept);
      formik.setFieldValue("counter_number", data.counter_number);
      setState(tempState);
    }
  }, [props.menuCategoryItems]);
  return (
    <React.Fragment>
      <Form>
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={"w-100 bg-white"} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        <div className="f16-700 mb-3">Availability Of Item</div>
        <div className="f14-700 mb-3">Item Availability</div>
        <div className="d-flex align-items-center flex-wrap">
          {/* <div
            className="d-flex align-items-center mr-3 mb-3"
            onClick={handleShow24Hours}
          >
            <Form.Check label="1" inline className="enCheckBoxOnly" />
            <div className="f11-700">All Day</div>
          </div> */}
          {/* <div className="d-flex align-items-center mr-3 mb-3">
            <Form.Check label="1" inline className="enCheckBoxOnly" />
            <div className="f11-700">Breakfast</div>
          </div>
          <div className="d-flex align-items-center mr-3 mb-3">
            <Form.Check label="1" inline className="enCheckBoxOnly" />
            <div className="f11-700">Lunch</div>
          </div>
          <div className="d-flex align-items-center mr-3 mb-3">
            <Form.Check label="1" inline className="enCheckBoxOnly" />
            <div className="f11-700">Dinner</div>
          </div>
          <div className="d-flex align-items-center mr-3 mb-3">
            <Form.Check label="1" inline className="enCheckBoxOnly" />
            <div className="f11-700">Supper</div>
          </div>
          <div className="d-flex align-items-center mr-3 mb-3">
            <Form.Check label="1" inline className="enCheckBoxOnly" />
            <div className="f11-700">Brunch</div>
          </div>
          <div className="d-flex align-items-center mr-3 mb-3">
            <Form.Check label="1" inline className="enCheckBoxOnly" />
            <div className="f11-700">Other Times</div>
          </div> */}
          {itemAvaiblity.map((item, index) => (
            <div className="d-flex align-items-center mr-3 mb-3" key={index}>
              <Form.Check
                label="1"
                checked={
                  formik.values.opening_time.includes(item) ? true : false
                }
                onClick={() => addRemoveItem(item)}
                inline
                className="enCheckBoxOnly"
              />
              <div className="f11-700">{item}</div>
            </div>
          ))}
        </div>

        <Modal show={show24Hours} onHide={handleClose24Hours} centered>
          <Modal.Header className="border-0" closeButton></Modal.Header>
          <Modal.Body>
            <div className="f16-700 pb-4">Hours of Item Availability</div>
            <div className="f14-400 text-dark">
              Yes, we are open for you <b>24x7.</b>
            </div>
            <div className="f11-400 opacity5">Visit us anytime.</div>
            <Image
              width="250px"
              className="my-4"
              src={require("../../../../../../../../assets/images/illustratorImage/Time_Illustrations-01.svg")}
            />
          </Modal.Body>
        </Modal>
        <React.Fragment>
          <div className="multiple-opening-time-section pt-4">
            <div className="row pb-3">
              <div className="col-10">
                <div className="f18-700">
                  Item is available at certain times?
                </div>
                <div className="f12-400 opacity5">
                  If you have multiple timing for item availabiility
                </div>
              </div>
              <div className="col-2">
                <Switch
                  // checked={multipleOpeningTimes}
                  // onChange={handleChangeMultiple}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={20}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={14}
                  width={34}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                />
              </div>
            </div>
            <hr />
            <div className="f16-700">
              Which Days and Times of the Week Item is available ?
            </div>
          </div>
          <div className="onboarding_process_screen-left-mapinside px-0">
            <div className="business_and_hours_onboarding_main">
              <RenderMultipleHoursInsideFields
                state={state}
                errors={state.errors}
                onDayOpenCloseHanlder={onDayOpenCloseHanlder}
                addOnClick={onMultipleAddHandler}
                deleteOnClick={onMultileDeleteHandler}
                handleChangeOpeningCloseing={handleChangeOpeningCloseing}
                handleChangeInputTextArray={handleChangeInputTextArray}
                handleChangeMultipleHoursToggle={
                  handleChangeMultipleHoursToggle
                }
                onFocusOut={onFocusOut}
                copyMultipleTimeFunctionError={copyMultipleTimeFunctionError}
                copyMultipleTimeFunction={copyMultipleTimeFunction}
              />
            </div>
          </div>
        </React.Fragment>
        <div className="d-flex align-items-center justify-content-between py-3">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Item Status Active
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <ToggleButtonWithYesNo
              checkedBox={formik.values.status}
              onChange={() => onChangeItemStatus()}
            />
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between py-3">
          <div className="f14-700 col-8 col-md-8 col-lg-6 p-0">
            Auto - Accept
          </div>
          <div className="col-4 col-md-4 col-lg-6">
            <ToggleButtonWithYesNo
              checkedBox={formik.values.auto_accept}
              onChange={() => onChangeAutoAccept()}
            />
          </div>
        </div>
        <div className="flex-wrap d-flex align-items-center">
          <div className="col-12 col-md-8 col-lg-6 px-0 py-3">
            <div className="f14-700">Counter Number / Name</div>
            <div className="f9-400 opacity5">
              ( Counter Number or Name where customer can pick up the Item in
              the order, this is a required information for Take Away And Skip
              The Line)
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-4 py-3">
            <NewInputText
              extraClass="mb-0"
              name="counter_number"
              value={formik.values.counter_number}
              onChange={formik.handleChange}
            />
          </div>
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="btn-lg btn btn-outline-secondary"
            buttonText="Back"
            buttonType="button"
            onClick={() => onClickBack()}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
            buttonText="Save and Next"
            buttonType="button"
            //onClick={onSubmit}
            onClick={(e) => onClickNext(e)}
          />
        </div>
      </Form>
    </React.Fragment>
  );
};
const RenderMultipleHoursInsideFields = ({
  state,
  errors,
  onDayOpenCloseHanlder,
  handleChangeOpeningCloseing,
  handleChangeInputTextArray,
  handleChangeMultipleHoursToggle,
  onFocusOut,
  deleteOnClick,
  addOnClick,
  copyMultipleTimeFunction,
  copyMultipleTimeFunctionError,
}) => {
  const dayDataMonData = state.monday.multiple_timings;
  let dayDataMonDataDesc =
    dayDataMonData[dayDataMonData.length - 1] &&
    dayDataMonData[dayDataMonData.length - 1].description;
  const dayDataTueData = state["tuesday"].multiple_timings;
  let dayDataTueDataDesc =
    dayDataTueData[dayDataTueData.length - 1] &&
    dayDataTueData[dayDataTueData.length - 1].description;
  const dayDataWedData = state["wednesday"].multiple_timings;
  let dayDataWedDataDesc =
    dayDataWedData[dayDataWedData.length - 1] &&
    dayDataWedData[dayDataWedData.length - 1].description;
  const dayDataThrData = state["thursday"].multiple_timings;
  let dayDataThrDataDesc =
    dayDataThrData[dayDataThrData.length - 1] &&
    dayDataThrData[dayDataThrData.length - 1].description;
  const dayDataFriData = state["friday"].multiple_timings;
  let dayDataFriDataDesc =
    dayDataFriData[dayDataFriData.length - 1] &&
    dayDataFriData[dayDataFriData.length - 1].description;
  const dayDataSatData = state["saturday"].multiple_timings;
  let dayDataSatDataDesc =
    dayDataSatData[dayDataSatData.length - 1] &&
    dayDataSatData[dayDataSatData.length - 1].description;
  const dayDataSunData = state["sunday"].multiple_timings;
  let dayDataSunDataDesc =
    dayDataSunData[dayDataSunData.length - 1] &&
    dayDataSunData[dayDataSunData.length - 1].description;

  return (
    <React.Fragment>
      <div className="margin-new-multiple-hours mb-5">
        {dayArray.map((day, index) => (
          <React.Fragment key={index}>
            <div className="standard-hours-main">
              <div className="standard-hours-main-sectionone">
                <Switch
                  checked={state[day].open}
                  onChange={onDayOpenCloseHanlder(day, foodTime, "multiple")}
                  offColor="#EEEEEE"
                  onColor="#EEEEEE"
                  offHandleColor="#212121"
                  onHandleColor="#59F832"
                  handleDiameter={15}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={10}
                  width={28}
                  boxShadow="-2px 0px 5px #0000003B"
                  activeBoxShadow="-2px 0px 5px #0000003B"
                  id="material-switch"
                />
                <div className="f12-500 text-uppercase pl-2">{day}</div>
              </div>
              {state[day].open === true ? (
                <div className="">
                  {state[day].multiple_timings.map((hours, index) => (
                    <div
                      className="row mb-4 mt-3 pl-md-4 pl-lg-4 pl-xl-4 standard-hours-main-sectiontwo"
                      key={index}
                    >
                      <div className="col-4 col-sm-4 col-md-5 col-lg-5 col-xl-5">
                        <div className="d-flex align-items-center justify-content-between">
                          <Switch
                            checked={hours.open}
                            onChange={handleChangeMultipleHoursToggle(
                              day,
                              hours,
                              index
                            )}
                            offColor="#EEEEEE"
                            onColor="#EEEEEE"
                            offHandleColor="#212121"
                            onHandleColor="#59F832"
                            handleDiameter={15}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={10}
                            width={28}
                            boxShadow="-2px 0px 5px #0000003B"
                            activeBoxShadow="-2px 0px 5px #0000003B"
                            id="material-switch"
                          />
                          <NewInputText
                            extraClass="mb-0 ml-3"
                            inputType="text"
                            onChange={handleChangeInputTextArray(day, index)}
                            onFocusOut={onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={hours.description}
                            name="description"
                            errorText={
                              hours.description === "" ? errors.description : ""
                            }
                            errorTrue={
                              hours.description === "" &&
                              errors.description === "Description Is Required"
                                ? true
                                : false
                            }
                            disabled={hours.open === true ? false : true}
                            labelText="Description"
                            controlClass={
                              hours.description === "" &&
                              errors.description === "Description Is Required"
                                ? "outlined-error-helper-text"
                                : "outlined-helperText"
                            }
                          />
                        </div>
                      </div>
                      <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 standard-hours-main-sectiontwo-insidetoggle ">
                        <TimeInput
                          mode="12h"
                          value={new Date(hours.opening_time)}
                          disabled={hours.open === true ? false : true}
                          onChange={(time) =>
                            handleChangeOpeningCloseing(
                              time,
                              day,
                              "opening_time",
                              index
                            )
                          }
                        />
                      </div>
                      <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 standard-hours-main-sectiontwo-insidetoggle mobile-standard-hours-mainpending">
                        <TimeInput
                          mode="12h"
                          value={new Date(hours.closing_time)}
                          disabled={hours.open === true ? false : true}
                          onChange={(time) =>
                            handleChangeOpeningCloseing(
                              time,
                              day,
                              "closing_time",
                              index
                            )
                          }
                        />
                      </div>
                      <div className="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1 p-0 d-flex align-items-center justify-content-between">
                        {state[day].multiple_timings.length > 1 ? (
                          <div>
                            <AddButtonIconComponent
                              buttonText="Delete"
                              onClick={deleteOnClick(day, index)}
                              fontIcon="fa fa-trash-o"
                              colorCss="delete"
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ))}
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 restaurant_details_onboarding_minus_button">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <AddButtonIconComponent
                        buttonText="Add Another Slot"
                        onClick={addOnClick(day)}
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
                      <AddButtonIconComponent
                        buttonText="Copy Timing to Rest of the Days"
                        onClick={
                          (dayDataMonDataDesc === "" &&
                            dayDataTueDataDesc === "" &&
                            dayDataWedDataDesc === "" &&
                            dayDataThrDataDesc === "" &&
                            dayDataFriDataDesc === "" &&
                            dayDataSatDataDesc === "" &&
                            dayDataSunDataDesc === "") ||
                          state.checkPoint === true
                            ? copyMultipleTimeFunctionError
                            : copyMultipleTimeFunction(day)
                        }
                        fontIcon="fa fa-clone"
                        colorCss="red"
                        displayIcon="clone"
                        //
                      />
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </React.Fragment>
  );
};

Availability.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  menuCategoryItems: state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding.activeItemId,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  update_item_menu_setup,
})(Availability);
